export const SUBSCRIPTIONS_API = `${process.env.DAP_BASE_URI}/subscriptions`;

export const SOLICITATION_API =
	'https://pcal1pbho5.execute-api.us-east-1.amazonaws.com/prod/proposers';
